import catalogServiceFactory from '../../../../common/services/catalog.factory';

class EditProductController {
  /* @ngInject */
  constructor($scope, $element, $rootScope, CatalogService, StorageService, MenuActions, MenuStore, ProductsActions, ProductsStore, StoreStates, FoundationApi) {
    const that = this;

    this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');

    that.loading = {
      product: false,
      categories: false,
      subCategories: false,
      menus: false
    };

    this.productImage = {
      coverImage: '',
      isCrop: false,
      position: false
    };

    this.isLoadingImage = false;
    this.errorImage = '';

    that.menus = [];

    this.variants = [];

    this.addVariant = () => {
      const variant = {
        id: Date.now(),
        name: '',
        availability: null
      };
      console.log('adding variant ', variant);
      if (!that.product.variants) {
        that.product.variants = [];
      }
      that.product.variants.push(variant);
    };

    that.removeVariant = id => {
      console.log('removing variant id ', id);
      that.product.variants = that.product.variants.filter(v => v.id !== id);
      console.log(that.product.variants);
    };

    this.resetModal = () => {
      that.productImage.isCrop = false;
      that.productImage.coverImage = '';
    };

    const loadCategories = () => {
      that.error = undefined;
      if (ProductsStore.getCategoriesStoreState() === StoreStates.STORE_VALID) {
        that.categories = ProductsStore.getCategories();

        if (that.mode === 'edit') {
          that.loadSubCategories();
        }

        that.loading.categories = false;
      } else if (ProductsStore.getCategoriesStoreState() !== StoreStates.STORE_PENDING_UPDATE) {
        that.loading.categories = true;
        ProductsActions.getCategories();
      }
    };

    const loadMenus = () => {
      if (MenuStore.getMenuStoreState() === StoreStates.STORE_VALID) {
        that.menus = MenuStore.getMenus();
        that.loading.menus = false;
      } else if (MenuStore.getMenuStoreState() === StoreStates.STORE_PENDING_UPDATE) {
        that.loading.menus = true;
      } else {
        that.loading.menus = true;
        MenuActions.getMenus();
      }
    };

    const loadImageProduct = () => {
      CatalogService.getImageProduct(that.product.id).then(res => {
        that.productImage.coverImage = res;
      });

    };

    const init = () => {
      $element.on('change', (e) => {
        handleFileSelect(e.target);
      });
      if (that.mode === 'create') {
        that.product = {
          menus: [],
          variants: []
        };
        loadMenus();
      } else if (that.mode === 'edit') {
        CatalogService.getProductVariants(that.product).then(response => {
          if (response && response.data) {
            that.originalDataVariants = JSON.parse(JSON.stringify(response.data));
            that.product.variants = response.data;
          }
          console.log(response);
        });


        if (that.product.hasCoverPhoto) {
          loadImageProduct();
        }
        that.product.price = that.product.price.replace('.', ',');
      }

      loadCategories();
    };

    that.$onInit = init;

    that.loadSubCategories = () => {
      that.error = undefined;
      if (ProductsStore.getSubCategoriesStoreState(that.product.category.key) === StoreStates.STORE_VALID) {
        that.subCategories = ProductsStore.getSubCategories(that.product.category.key);
        that.loading.subCategories = false;
      } else if (ProductsStore.getSubCategoriesStoreState(that.product.category.key) !== StoreStates.STORE_PENDING_UPDATE) {
        let deregSubCategoriesFailListener = undefined;
        let deregSubCategoriesUpdateListener = undefined;

        deregSubCategoriesUpdateListener = $rootScope.$on(`SUBCATEGORIES_UPDATE_${that.product.category.key}`, () => {
          deregSubCategoriesUpdateListener();
          deregSubCategoriesFailListener();
          that.loadSubCategories();
        });

        deregSubCategoriesFailListener = $rootScope.$on(`SUBCATEGORIES_FAIL_${that.product.category.key}`, () => {
          deregSubCategoriesFailListener();
          deregSubCategoriesUpdateListener();
          that.error = ProductsStore.getSubCategoriesError(that.product.category.key);
          that.loading.subCategories = false;
        });

        that.loading.subCategories = true;
        that.product.subCategory = null;
        ProductsActions.getSubCategories(that.product.category.key);
      }
    };

    this.resizeImage = () => {
      that.productImage.isCrop = false;
      that.productImage.coverImage = that.myCroppedCover;
      that.product.img = that.myCroppedCover;
      that.productImage.coverImageBase64 = undefined;
      that.errorImage = '';
    };

    that.saveProduct = () => {
      if (ProductsStore.getProductsStoreState() === StoreStates.STORE_PENDING_UPDATE) return;

      that.loading.product = true;

      switch (that.mode) {
        case 'create':
        default:
          ProductsActions.createProduct(that.product);
          break;
        case 'edit':
          ProductsActions.editProduct(that.product);
          break;
      }
    };



    const handleFileSelect = (evt) => {
      that.errorImage = '';
      if (evt.files === null || evt.files == undefined) return;
      const file = evt.files[0];
      if (file.size > 1048576) {
        that.errorImage = 'Dimensione massima di caricamento 1MB';
        return;
      } else if (!/png/.test(file.type) && !/jpeg/.test(file.type)) {
        that.errorImage = 'Estensione consentita PNG - JPG';
        return;
      }
      that.productImage.isCrop = true;
      const reader = new FileReader();
      reader.onload = (evnt) => {
        $scope.$apply(() => {
          that.productImage.coverImage = evnt.target.result;
        });
      };
      reader.readAsDataURL(file);
    };

    that.toggleSelectMenu = menuId => {
      const menuIndex = that.product.menus.indexOf(menuId);
      if (menuIndex > -1) {
        that.product.menus.splice(menuIndex, 1);
      } else {
        that.product.menus.push(menuId);
      }
    };
    const deregUpdateProductListener = $rootScope.$on('SAVEPRODUCT', () => {
      CatalogService.editVariants(that.product, that.originalDataVariants);
    });
    const deregSaveProductListener = $rootScope.$on('SAVEPRODUCT', that.onCancel);
    const deregProductSavedFailedListener = $rootScope.$on('SAVEPRODUCT_FAIL', () => {
      that.error = ProductsStore.getProductsError();
      that.loading.product = false;
    });

    const deregCategoriesUpdateListener = $rootScope.$on('CATEGORIES_UPDATE', loadCategories);

    const deregMenuUpdateListener = $rootScope.$on('MENU_UPDATE', loadMenus);
    const deregMenuUpdateFailListener = $rootScope.$on('MENU_FAIL', () => {
      that.loading.menus = false;
    });

    that.$onDestroy = () => {
      deregSaveProductListener();
      deregUpdateProductListener();
      deregProductSavedFailedListener();
      deregCategoriesUpdateListener();
      deregMenuUpdateListener();
      deregMenuUpdateFailListener();
    };
  }
}

export default EditProductController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/catalog/edit/edit.controller.js
 **/